import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei'

export function Ankk(props) {
    const group = useRef();
    const { nodes } = useGLTF('3ds/an/Ankk.gltf');
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                name="Ankk"
                geometry={nodes.Ankk.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/Ankk.gltf')